module.exports = __webpack_public_path__ + "img/checkbox-selected.eece8b1f.svg";